
import React from 'react';

const AboutSection: React.FC = () => {
  return (
    <section id="about" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Giặt Ủi Minh Khôi - Dịch Vụ Giặt Ủi Chuyên Nghiệp Hàng Đầu tại Đà Lạt
            </h2>
            <p className="text-xl text-gray-600 max-w-4xl mx-auto">
              Bạn đang tìm kiếm một giải pháp giặt ủi đáng tin cậy tại Đà Lạt? Với hệ thống máy móc công nghiệp hiện đại, được đầu tư theo tiêu chuẩn khách sạn 4-5 sao, Giặt Ủi Minh Khôi tự hào là đối tác hàng đầu, mang đến dịch vụ chất lượng cao cho cả doanh nghiệp và gia đình.
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-16">
            <div>
              <img 
                src="https://public.readdy.ai/ai/img_res/dc154899f7c8dee0b45c9990ddb91d75.jpg"
                alt="Hệ thống máy giặt công nghiệp hiện đại tại xưởng giặt ủi Minh Khôi Đà Lạt"
                className="w-full h-96 object-cover object-top rounded-2xl shadow-lg"
              />
            </div>
            <div>
              <h3 className="text-2xl font-bold text-gray-900 mb-6">
                Chúng tôi hiểu rằng sự sạch sẽ, thơm tho và chuyên nghiệp của trang phục, khăn trải giường, khăn tắm... là yếu tố quan trọng góp phần vào thành công của bạn. Đó là lý do chúng tôi luôn nỗ lực không ngừng để mang đến sự hài lòng tuyệt đối.
              </h3>
              <p className="text-gray-600 mb-6 leading-relaxed">
                Với đội ngũ nhân viên giàu kinh nghiệm và quy trình làm việc chuyên nghiệp, chúng tôi cam kết mang đến những giá trị vượt trội cho khách hàng tại Đà Lạt.
              </p>
              
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div className="flex items-center">
                  <div className="w-8 h-8 bg-teal-100 rounded-full flex items-center justify-center mr-3">
                    <i className="ri-hotel-line text-teal-600"></i>
                  </div>
                  <span className="text-gray-700">Khách sạn & Resort</span>
                </div>
                <div className="flex items-center">
                  <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center mr-3">
                    <i className="ri-home-line text-blue-600"></i>
                  </div>
                  <span className="text-gray-700">Hộ gia đình</span>
                </div>
                <div className="flex items-center">
                  <div className="w-8 h-8 bg-purple-100 rounded-full flex items-center justify-center mr-3">
                    <i className="ri-service-line text-purple-600"></i>
                  </div>
                  <span className="text-gray-700">Spa & Massage</span>
                </div>
                <div className="flex items-center">
                  <div className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center mr-3">
                    <i className="ri-restaurant-line text-green-600"></i>
                  </div>
                  <span className="text-gray-700">Nhà hàng</span>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-gradient-to-r from-teal-50 to-blue-50 rounded-2xl p-8 mb-16">
            <h3 className="text-3xl font-bold text-gray-900 mb-8 text-center">
              Tại Sao Chọn Dịch Vụ Giặt Ủi Minh Khôi tại Đà Lạt?
            </h3>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div className="bg-white rounded-xl p-6 shadow-sm">
                <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mb-4">
                  <i className="ri-settings-3-line text-blue-600 text-xl"></i>
                </div>
                <h4 className="font-semibold text-gray-900 mb-3 text-lg">Hệ Thống Máy Móc Chuẩn 5 Sao</h4>
                <p className="text-gray-600">Sử dụng trang thiết bị giặt, sấy, ủi công nghiệp hiện đại, đảm bảo xử lý số lượng lớn vải vóc một cách nhanh chóng, hiệu quả và an toàn cho mọi chất liệu.</p>
              </div>

              <div className="bg-white rounded-xl p-6 shadow-sm">
                <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mb-4">
                  <i className="ri-shield-check-line text-green-600 text-xl"></i>
                </div>
                <h4 className="font-semibold text-gray-900 mb-3 text-lg">Chất Lượng Sạch Vượt Trội</h4>
                <p className="text-gray-600">Chúng tôi sử dụng hóa chất giặt tẩy chuyên dụng, an toàn, giúp loại bỏ hoàn toàn vết bẩn cứng đầu, giữ cho vải luôn mềm mại, bền màu và thơm mát dài lâu.</p>
              </div>

              <div className="bg-white rounded-xl p-6 shadow-sm">
                <div className="w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center mb-4">
                  <i className="ri-money-dollar-circle-line text-purple-600 text-xl"></i>
                </div>
                <h4 className="font-semibold text-gray-900 mb-3 text-lg">Tiết Kiệm Thời Gian & Chi Phí</h4>
                <p className="text-gray-600">Quy trình tối ưu giúp khách hàng tiết kiệm tối đa thời gian và chi phí vận hành, để bạn có thể tập trung vào hoạt động kinh doanh cốt lõi.</p>
              </div>

              <div className="bg-white rounded-xl p-6 shadow-sm">
                <div className="w-12 h-12 bg-orange-100 rounded-full flex items-center justify-center mb-4">
                  <i className="ri-team-line text-orange-600 text-xl"></i>
                </div>
                <h4 className="font-semibold text-gray-900 mb-3 text-lg">Đội Ngũ Kinh Nghiệm</h4>
                <p className="text-gray-600">Nhân viên am hiểu sâu sắc về ngành giặt công nghiệp, sẵn sàng tư vấn giải pháp tối ưu nhất cho từng nhu cầu cụ thể của bạn.</p>
              </div>
            </div>
          </div>

          <div className="bg-gradient-to-r from-blue-50 to-teal-50 rounded-2xl p-8">
            <h3 className="text-3xl font-bold text-gray-900 mb-8 text-center">
              Đối Tác Giặt Ủi Tin Cậy Cho Mọi Nhu Cầu
            </h3>
            <p className="text-center text-gray-600 mb-8 text-lg">
              Giặt Ủi Minh Khôi tự hào là nhà cung cấp dịch vụ cho đa dạng các đối tác tại Đà Lạt:
            </p>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="bg-white rounded-xl p-6 shadow-sm">
                <div className="flex items-center mb-4">
                  <div className="w-12 h-12 bg-teal-100 rounded-full flex items-center justify-center mr-4">
                    <i className="ri-hotel-line text-teal-600 text-xl"></i>
                  </div>
                  <h4 className="font-semibold text-gray-900 text-lg">🏨 Khách sạn & Resort</h4>
                </div>
                <p className="text-gray-600">Xử lý chuyên nghiệp chăn, ga, gối, rèm cửa, khăn tắm, đồng phục nhân viên... đảm bảo tiêu chuẩn vệ sinh khắt khe nhất.</p>
              </div>

              <div className="bg-white rounded-xl p-6 shadow-sm">
                <div className="flex items-center mb-4">
                  <div className="w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center mr-4">
                    <i className="ri-service-line text-purple-600 text-xl"></i>
                  </div>
                  <h4 className="font-semibold text-gray-900 text-lg">💆 Spa & Massage</h4>
                </div>
                <p className="text-gray-600">Cung cấp khăn spa, khăn tắm, ga trải giường luôn sạch sẽ, mềm mại, tạo cảm giác thư giãn và chuyên nghiệp cho khách hàng của bạn.</p>
              </div>

              <div className="bg-white rounded-xl p-6 shadow-sm">
                <div className="flex items-center mb-4">
                  <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mr-4">
                    <i className="ri-restaurant-line text-green-600 text-xl"></i>
                  </div>
                  <h4 className="font-semibold text-gray-900 text-lg">🍽️ Nhà hàng</h4>
                </div>
                <p className="text-gray-600">Giặt sạch khăn trải bàn, tạp dề, đồng phục... giúp duy trì hình ảnh sang trọng và sạch sẽ cho không gian ẩm thực.</p>
              </div>

              <div className="bg-white rounded-xl p-6 shadow-sm">
                <div className="flex items-center mb-4">
                  <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mr-4">
                    <i className="ri-home-line text-blue-600 text-xl"></i>
                  </div>
                  <h4 className="font-semibold text-gray-900 text-lg">🏠 Hộ gia đình & Cá nhân</h4>
                </div>
                <p className="text-gray-600">Giải pháp giặt sấy nhanh chóng, tiện lợi cho chăn màn, quần áo, rèm cửa... giúp bạn có thêm thời gian tận hưởng cuộc sống.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
